module.exports = __webpack_public_path__ + "static/media/edit.e8fcdfb3.svg";